export default __webpack_public_path__ + "static/media/jade_collection_1.75636ed5.jpeg";